import { create } from "zustand";
import { devtools } from "zustand/middleware";

const initialState = {
  activeApp: null,
  activeAppData: null,
  selectedApps: [],
  appFilterSearchQuery: {
    left_progression_filter: "",
    search: "",
    sortBy: "id",
    sortValue: "DESC",
    manager_id: [],
    uw_ids: [],
    progression_id: [],
    page: 1,
    user_id: "",
    organization_id: "",
    bank: null,
    created_from: "",
    created_to: "",
    rep_codes: [],
    channel: null,
  },
  pageCount: 0,
  totalItems: 0,
  itemsPerPage: 10,
  preapps: [],
  relationshipManagers:[],
};

const useApplicationStore = create(
  devtools((set) => ({
    ...initialState,
    setActiveApp: (app) => set({ activeApp: app }),
    setActiveAppData: (data) => set({ activeAppData: data }),
    setSelectedApps: (apps) => set({ selectedApps: apps }),
    setPreapps: (preapps) => set({ preapps }),
    setPageCount: (count) => set({ pageCount: count }),
    setAppFilterSearchQuery: (query) =>
      set((state) => ({
        appFilterSearchQuery: {
          ...state.appFilterSearchQuery,
          ...query,
        },
      })),
    setTotalItems: (total) => set({ totalItems: total }),
    setItemsPerPage: (items) => set({ itemsPerPage: items }),
    setRelationshipManagers: (relationshipManagers) => set({ relationshipManagers }),
    reset: () => set(initialState),
  })),
);

export default useApplicationStore;
